import { Component, OnInit, Input, NgModule } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { FormControl } from '../form-control.model';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';

@Component({
	selector: 'wncm-form-control-hour',
	templateUrl: './form-control-hour.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-hour.component.scss']
})
export class FormControlHourComponent extends FormControlComponent {
	lightTheme: NgxMaterialTimepickerTheme = {
		dial: {
			dialBackgroundColor: '#0B002C'
		},
		clockFace: {
			clockHandColor: '#0B002C'
		}
	};

	darkTheme: NgxMaterialTimepickerTheme = {
		container: {
			bodyBackgroundColor: '#424242',
			buttonColor: '#fff'
		},
		dial: {
			dialBackgroundColor: '#555'
		},
		clockFace: {
			clockFaceBackgroundColor: '#555',
			clockHandColor: '#0B002C',
			clockFaceTimeInactiveColor: '#fff'
		}
	};

	@Input()
	max: string;

	@Input()
	min: string;

	@Input()
	appearance = 'outline';

	@Input()
	readOnly: boolean;

	constructor() {
		super();
	
		if (this.readOnly) {
			this.control.disable();
		}
	}

	getCookie(cname) {
		const name = cname + '=';
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return false;
	}

	adaptTheme() {
		return this.getCookie('dark-theme');
	}
}
